import { render, staticRenderFns } from "./AdminHomeNeedCard.vue?vue&type=template&id=ee23342a&scoped=true"
import script from "./AdminHomeNeedCard.vue?vue&type=script&lang=js"
export * from "./AdminHomeNeedCard.vue?vue&type=script&lang=js"
import style0 from "./AdminHomeNeedCard.vue?vue&type=style&index=0&id=ee23342a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee23342a",
  null
  
)

export default component.exports